import { trace } from 'rytm-helpers'
import { KEY_CODE, isFunction, getFocusableChildren } from './../lib/helpers'

class Dialog {
  /**
  * Dialog class constructor  
  * @constructor
  * @param {String} id
  * @param {Object} params - {dialog: el, toggleBtn: btn}
  **/
  constructor(id, params) {
    this.id = id
    this.dialog = params.dialog ? params.dialog : false
    this.toggleBtn = params.toggleBtn ? params.toggleBtn : false
    this.onDialogOpen = params.onDialogOpen ? params.onDialogOpen : false
    this.onDialogClose = params.onDialogClose ? params.onDialogClose : false
    this.expanded = false
    this.trapSet = false
    this.uid = id + "-" + Math.round(Math.random() * 99999)
  }
  open() {
    if (this.expanded == false) {
      trace("[diaolog] open", this.id, this.uid)
      if (isFunction(this.onDialogOpen)) {
        this.onDialogOpen()
      }
      this.handleFocusOpen()
      // toggle aria-expanded
      if (this.toggleBtn) {
        if (this.toggleBtn.getAttribute("aria-expanded") == "false") {
          this.toggleBtn.setAttribute("aria-expanded", "true")
        }
      }
      this.expanded = true
    }
  }
  close() {
    if (this.expanded == true) {
      trace("[diaolog] close", this.id, this.uid)
      this.handleFocusClose()
      if (isFunction(this.onDialogClose)) {
        this.onDialogClose()
      }
      // toggle button aria-expanded
      if (this.toggleBtn) {
        if (this.toggleBtn.getAttribute("aria-expanded")) {
          this.toggleBtn.setAttribute("aria-expanded", "false")
        }
      }
      this.expanded = false
    }
  }
  destroy() {
    this.close()
  }
  handleFocusOpen() {
    const focusableFirst = this._getFirstFocusable()
    const focusableLast = this._getLastFocusable()
    if (focusableFirst) {
      setTimeout(() => {
        focusableFirst.focus()
      }, 50)
    }
    // add event listeners
    if (focusableFirst) {
      $(focusableFirst).on("keydown", $.proxy(this._onFirstFocusableKeydown, this))
    }
    if (focusableLast) {
      $(focusableLast).on("keydown", $.proxy(this._onLastFocusableKeydown, this))
    }
  }
  handleFocusClose() {
    // toggle button FOCUS
    if (this.toggleBtn) {
      this.toggleBtn.focus()
    }
    const focusableFirst = this._getFirstFocusable()
    const focusableLast = this._getLastFocusable()
    // remove event listeners
    if (focusableFirst) {
      $(focusableFirst).off("keydown", $.proxy(this._onFirstFocusableKeydown, this))
    }
    if (focusableLast) {
      $(focusableLast).off("keydown", $.proxy(this._onLastFocusableKeydown, this))
    }
  }

  _onFirstFocusableKeydown(e) {
    switch (e.keyCode) {
      case KEY_CODE.TAB:
        if (e.shiftKey) {
          // set focus on last!
          const focusableLast = this._getLastFocusable()
          if (focusableLast) {
            focusableLast.focus()
          }
          // prevent FOCUS
          e.stopPropagation()
          e.preventDefault()
        }
        break;
    }
  }
  _onLastFocusableKeydown(e) {
    switch (e.keyCode) {
      case KEY_CODE.TAB:
        if (!e.shiftKey) {
          // set focus on first!
          const focusableFirst = this._getFirstFocusable()
          if (focusableFirst) {
            focusableFirst.focus()
          }
          // prevent FOCUS
          e.stopPropagation()
          e.preventDefault()
        }
        break;
    }
  }

  _getAllFocusable() {
    return getFocusableChildren(this.dialog)
  }
  _getFirstFocusable() {
    const list = this._getAllFocusable()
    return list.length > 0 ? list[0] : false
  }
  _getLastFocusable() {
    const list = this._getAllFocusable()
    return list.length > 0 ? list[list.length - 1] : false
  }

}

export default Dialog